import NavbarComponent from "../components/NavbarComponent";
import React from "react";
import ApplicationTable from "../components/tables/ApplicationTable";

export default function ApplicationPage() {

    return(
        <div>
            <NavbarComponent initValue={"/application"}/>
            <ApplicationTable/>
        </div>
    )
}